"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsMobileXsOnly = exports.useIsMobileSmOnly = exports.useIsMobile = exports.useIsLandscape = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var useIsMobile = function useIsMobile() {
  var theme = (0, _styles.useTheme)();
  var isMobile = (0, _core.useMediaQuery)(theme.breakpoints.down('sm'), {
    noSsr: true
  });
  return isMobile;
};

exports.useIsMobile = useIsMobile;

var useIsMobileSmOnly = function useIsMobileSmOnly() {
  var theme = (0, _styles.useTheme)();
  var isMobileSmOnly = (0, _core.useMediaQuery)(theme.breakpoints.only('sm'), {
    noSsr: true
  });
  return isMobileSmOnly;
};

exports.useIsMobileSmOnly = useIsMobileSmOnly;

var useIsLandscape = function useIsLandscape() {
  var isLandscape = (0, _core.useMediaQuery)("(orientation: landscape)");
  return isLandscape;
};

exports.useIsLandscape = useIsLandscape;

var useIsMobileXsOnly = function useIsMobileXsOnly() {
  var theme = (0, _styles.useTheme)();
  var useIsMobileXsOnly = (0, _core.useMediaQuery)(theme.breakpoints.down('xs'), {
    noSsr: true
  });
  return useIsMobileXsOnly;
};

exports.useIsMobileXsOnly = useIsMobileXsOnly;